import { AUTH_ACTION, COMMON_TRANSFORM_RESPONSE_FUNCTION } from "../../../app/constants/api";
import { apiSlice } from "../../../app/redux/apiSlice";

const authApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    authAction: builder.mutation({
      query: ({ action, payload = {} }) => ({
        url: AUTH_ACTION.BASE,
        method: "POST",
        body: { action, payload },
      }),
      ...COMMON_TRANSFORM_RESPONSE_FUNCTION,
    }),
  }),
});

export const { useAuthActionMutation } = authApiSlice;
